// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1VTMb","head":"ProcedureTableInfo_head__10Rm-"};